import SearchFormDataQuality from './SearchFormDataQuality';

export default SearchFormDataQuality;
